import { render, staticRenderFns } from "./HistorialPedidos.vue?vue&type=template&id=416961a2&"
import script from "./HistorialPedidos.vue?vue&type=script&lang=js&"
export * from "./HistorialPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports